


$(document).ready(function() {
    // $("#toggleSearch").on('click', function(event){
    //     event.stopPropagation();
    //     $(this).closest(".search__field").addClass("show");
    //     $(this).closest(".search").addClass("show");
    //     // document.getElementById("closeMenuBtn").click();
    // });
    $('.bottomAction .dropdown ').hover(function() {
        $(this).find('.dropdown-menu').stop(true, true).delay(200).fadeIn(500);
    }, function() {
        $(this).find('.dropdown-menu').stop(true, true).delay(200).fadeOut(500);
    });
    // $('#mobile-menu').on('click', function(event){
    //     document.getElementById("dropdownAvatar").click();
    // });
   
         $('#mobile-menu').on('click', function(event){
            if ($(".dropdownAvatarLogin").hasClass("show")) {
               // alert("test");
             document.getElementById("dropdownAvatar").click();
            }
         });
      
    // $('#dropdownAvatar').on('click', function(event){
    //     document.getElementById("mobile-menu").click();
    // });
    
    // $("body").on('click',function(event){
    //     if (event.target.className == "recentItem") {
    //         return;
    //     }
    //     else if (event.target.className == "closeIcon removeSearchItem") {
    //         return;
    //     }else if (event.target.className == "text-right removeSearch") {
    //         return;
    //     }
    //     $('.search__field').removeClass("show");
    //     $('.search').removeClass("show");
    //     $('.search__field').removeClass("error");
    //     $('.search__field').find('input').val('');
    // })
    // $(".search__field input, .search__field button[type='submit']").on('click',function(event){
    //     event.stopPropagation();

    // }) 
    // $('.alert').alert()

   
    
});

// $(window).scroll(function() {
	
//     if ($(this).scrollTop() > 300){
//         $('.header__sticky').addClass("sticky");
//     }
//     else{
//         $('.header__sticky').removeClass("sticky");
//     }
	
// });


